import React from "react";
import "./Footer.css";
export default function Footer() {
  return (
    <div className="footer-effect">
      {/* <a href="" target="blank" className="icon-btn facebook-icn"></a>
      <a href="" target="blank" className="icon-btn twitter-icn">
        <i className="fa fa-twitter"></i>
      </a>
      <a href="" target="blank" className="icon-btn instagram-icn">
        <i className="fa fa-instagram"></i>
      </a>
      <br />
      <br /> */}
     
      <p>COPYRIGHT © 2023 Niteesh Kamal Chaudhary</p>
    </div>
  );
}
